import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { types } from "../../../types";

const CustomSingleSelect = ({
  value,
  onChange,
  options,
  className,
  // editingEvent,
  // editingOptions = [],
}) => {
  const dispatch = useDispatch();

  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) : "";
  };

  useEffect(() => {
    dispatch({
      type: types.setCampusFromCollege,
      payload: value,
    });
    //eslint-disable-next-line
  }, [value]);

  return (
    <div className={className}>
      <Select
        // defaultValue={``}
        // defaultValue={options}
        onChange={(value) => onChange(value)}
        options={options}
        value={defaultValue(options, value)}
      />
    </div>
  );
};

export default CustomSingleSelect;
